
import { Component, Prop, Vue } from '~/utility/pu-class-decorator'

@Component
export default class FilterAndSortRadius extends Vue {
  @Prop({ required: true })
  radius: number

  radiusChanged(radius: number) {
    if (radius !== this.radius) {
      this.$emit('radiusChange', radius)
    }
  }
}
